module.exports = __webpack_public_path__ + "img/riot-fm.a144de7f.png";